import Api from "./Api";

export default {
  /**
  * Get All PrivateScamas
  */
  getAll() {
    return Api.get("/pscamas/");
  },

  /**
  * Get PrivateScama
  */
  get(id) {
    return Api.get("/pscamas/"+id);
  },

  /**
  * Create new PrivateScama
  */
  create(form) {
  	return Api.post("/pscamas", form,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
     );
	},

  /**
  * Delete PrivateScama
  */
  delete(id) {
    return Api.delete("/pscamas/"+id);
  },

  /**
  * Update PrivateScama
  */
  edit(id, form) {
    return Api.post("/pscamas/"+id+"/edit", form,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
     );
  },

};